export class SidebarConstants {
  public static navbarTabs(disableDiscoverTab, disableMeetTab,
    disableRecoverTab, disableEngageTab,
    disableCalendarTab, enableTemplateManagement, enableDashboard): any[] {
    let tabs = [];

    // Dashboard tab - shown when feature flag is enabled
    if (enableDashboard) {
      tabs.push({
        icon: 'dashboard',
        label: 'Dashboard',
        url: '/dashboard',
        active: false,
        hasSubmenu: false,
        external: true
      });
    }

    // Home tab - always shown
    tabs.push({
      icon: 'search',
      label: 'Discover',
      url: '/discover',
      active: false,
      hasSubmenu: false
    });

    if (!disableMeetTab) {
      tabs.push({
        icon: 'user',
        label: 'Meet',
        url: '/meet',
        active: false,
        hasSubmenu: true,
        submenuItems: [
          { label: 'My Spotlight', url: '/meet' },
          { label: 'Analytics', url: '/meet/analytics' }
        ]
      });
    }

    if (!disableRecoverTab) {
      tabs.push({
        icon: 'heart',
        label: 'Recover',
        url: '/care',
        active: false,
        hasSubmenu: true,
        submenuItems: [
          { label: 'CARES Contacts', url: '/care', queryParams: { index: 0 } },
          { label: 'Closed CARES', url: '/care', queryParams: { index: 1 } },
          { label: 'CFA One Contacts', url: '/care', queryParams: { index: 2 } },
          { label: 'Closed CFA One', url: '/care', queryParams: { index: 3 } },
          { label: 'Analytics', url: '/care', queryParams: { index: 4 } }
        ]
      });
    }

    if (!disableEngageTab) {
      let engageTab = {
        icon: 'award',
        label: 'Engage',
        url: '/engage/template-selection',
        active: false,
        hasSubmenu: true,
        submenuItems: [
          { label: 'Rewards', url: '/engage/template-selection', queryParams: { engagementIndex: 0 } },
          { label: 'Events', url: '/engage/template-selection', queryParams: { engagementIndex: 1 } },
          { label: 'Emails', url: '/engage/template-selection', queryParams: { engagementIndex: 2 } },
          { label: 'Analytics', url: '/engage/template-selection', queryParams: { engagementIndex: 3 } }
        ]
      }
      if (enableTemplateManagement) {
        engageTab.submenuItems.push( {
          label: 'Template Management',
          url: '/engage/template-selection',
          queryParams: { engagementIndex: 4 }
        })
      }
      tabs.push(engageTab);
    }

    if (!disableCalendarTab) {
      tabs.push({
        icon: 'calendar',
        label: 'Calendar',
        url: '/calendar',
        active: false,
        hasSubmenu: false
      });
    }

    return tabs;
  }
}

